var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dda-footer" }, [
      _c("div", { staticClass: "nem-wrapper" }, [
        _c("div", { staticClass: "dda-footer__content" }, [
          _c("p", [
            _vm._v("Danmarks Digitale Advokater 2020 "),
            _c("span", { staticClass: "dda-footer-text-line" }, [_vm._v("-")]),
            _vm._v(" "),
            _c("span", [_vm._v("CVR 33383053")])
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.nemadvokat.dk/nemblik/",
                target: "_blank"
              }
            },
            [_vm._v("Hjælp til login")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c53c58a2", { render: render, staticRenderFns: staticRenderFns })
  }
}